import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { myAccountSelector } from 'state/selectors/account';

const usePermissionDomainGate = () => {
  const account = useSelector(myAccountSelector);

  const isPermitted = useCallback(
    (permissionDomain, permissionAction) => {
      const { permissions } = account;

      if (!permissions) {
        return false;
      }

      return permissions[permissionDomain]?.includes(permissionAction) ?? false;
    },
    [account]
  );

  return { isPermitted };
};

export default usePermissionDomainGate;
